<div class="gc-dg-cards gc-dg-mt-5 gc-dg-mb-5">
    <h3 class="gc-dg-font-semibold gc-dg-font-lg">Billing address</h3>
    <div data-testid="gc-dg-billing-address" class="gc-dg-inner-card-container">
        <p>
            <span>{{customerTitle}}</span> <span>{{customerFirstName}}</span>
            <span>{{customerLastName}}</span>
        </p>
        <p>
            <span>{{number}} </span><span>{{street}}, </span
            ><span>{{postalCode}}, </span> <span>{{stateCode}}, </span
            ><span>{{city}}</span>
        </p>
    </div>
</div>
